<template>
    <div ref="container"
         :style="[elementStyles, basicContentStyles]">
        <div :style="[alignmentStyles, { textShadow: textShadow }]">
            <span :class="{
                      'newsticker': data.text_animation_type == 'newsticker',
                      'element-text-preview-transitions' : transitionText
                  }"
                  :dir="direction"
                  :style="[textStyles]"
                  class="text">{{ data.text_input }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                fontfamily: 'Arial',
                fontsize: '30',
                valign: 'top',
                align: 'left',
                prevRelevantData: '',
                prevHeight: 0,
                prevWidth: 0,

                transitionText: false
            }
        },
        computed: {
            elementStyles: function() {
                let backOpacity = 1;
                if(!isNaN(this.data.back_transparency) && this.data.back_transparency !== null) {
                    backOpacity -= this.data.back_transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                backOpacity = Math.min(backOpacity, 0.999);
                let backgroundColor = 'rgba(' + this.hexToRgb(this.data.secondary_color.replace('#','')) + ',' + backOpacity + ')';
                let opacity = 1;
                if(!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }

                return {
                    backgroundColor: backgroundColor,
                    opacity: opacity,
                    color: this.data.primary_color,
                };
            },
            textStyles: function () {
                return {
                    fontSize: this.fontsize + 'pt',
                    fontFamily: '"' + this.fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    wordWrap: 'normal',
                    whiteSpace: 'pre-wrap',
                    userSelect: 'none'
                }
            },
            alignmentStyles: function() {
                let top = '0%';
                let left = '0%';

                if(this.valign === 'middle') {
                    top = '50%';
                } else if(this.valign === 'bottom') {
                    top = '100%';
                }

                if(this.align === 'center') {
                    left = '50%';
                } else if(this.align === 'right') {
                    left = '100%';
                }

                return {
                    textAlign: this.data.text_align,
                    position: 'relative',
                    top: top,
                    left: left,
                    transform: 'translate(-' + left + ',-' + top + ')',
                    lineHeight: 'normal',
                    fontSize: 0,
                }
            },
            textDecoration: function () {
                if (this.data.text_decoration === 'underline') {
                    return 'underline';
                }

                return 'none';
            },
            fontStyle: function () {
                if (this.data.text_style === 'italic') {
                    return 'italic';
                }

                return 'normal';
            },
            fontWeight: function () {
                if (this.data.text_weight === 'bold') {
                    return 'bold';
                }

                return 'normal';
            },
            direction: function() {
                if(this.data.text_direction === 'ltr') {
                    return 'ltr';
                } else {
                    return 'rtl';
                }
            },
            textShadow: function () {
                if(this.data.drop_shadow != null && this.data.drop_shadow !== '' && this.data.drop_shadow > 0) {
                    const fontResizeRatio = this.fontsize / parseInt(this.data.text_size)
                    const d = parseInt(this.data.drop_shadow) * fontResizeRatio;
                    const b = 4 * fontResizeRatio;
                    return `${d}px ${d}px ${b}px black`;
                } else {
                    return '';
                }
            },
            relevantData: function () {
                return [
                    this.data.text_size,
                    this.data.text_family,
                    this.data.text_valign,
                    this.data.text_align,
                    this.data.text_input,
                    this.data.text_autoscale,
                    this.fontWeight,
                    this.direction,
                    this.fontStyle,
                    this.textShadow,
                    this.textDecoration,
                ].join('|');
            }
        },
        watch: {
            data: {
                handler: function () {
                    this.calcFontWrapper();
                },
                deep: true,
            },
            width: function () {
                this.calcFontWrapper();
            },
            height: function () {
                this.calcFontWrapper();
            },
        },
        methods: {
            setPrevValues: function () {
                this.prevRelevantData = this.relevantData;
                this.prevWidth = this.width;
                this.prevHeight = this.height;
            },
            calcFontWrapper: function () {
                if (this.prevHeight !== this.height || this.prevWidth !== this.width || this.prevRelevantData !== this.relevantData) {
                    this.calcFont();
                    this.setPrevValues();
                }
            },
            measureText: function (testContainer, scale) {
                if(testContainer) {
                    testContainer.style['font-size'] = this.fontsize*scale + 'pt';

                    return {
                        x: Math.max(testContainer.scrollWidth, 1),
                        y: Math.max(testContainer.scrollHeight, 1),
                    }
                } else {
                    return {
                        x: 0,
                        y: 0
                    }
                }
            },
            calcFont: function () {
                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size !== '') {
                    this.fontsize = (parseInt(this.data.text_size) * this.frame.ratio) ;
                }
                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    this.fontfamily = this.data.text_family;
                }
                this.valign = this.data.text_valign;
                this.align = this.data.text_align;

                let autoscale = parseFloat(this.data.text_autoscale);
                if (autoscale !== 0 && Math.abs(autoscale) <= 1) {

                    /*this.fontsize = calculateFontAutosize(
                        this.$refs.container,
                        this.width,
                        this.height,
                        this.data.text_input,
                        {
                            fontFamily: this.textStyles.fontFamily,
                            fontStyle: this.textStyles.fontStyle,
                            textDecoration: this.textStyles.textDecoration,
                            fontWeight: this.textStyles.fontWeight
                        },
                        8,
                        autoscale
                    )*/

                    let parentContainer = document.createElement('div');
                    parentContainer.style.position = 'absolute';
                    parentContainer.style['width'] = this.width + 'px';
                    parentContainer.style['height'] = this.height + 'px';
                    parentContainer.style['overflow'] = 'auto';
                    //parentContainer.style['text-shadow'] = this.textShadow;
                    parentContainer.style['line-height'] = '1.15';
                    parentContainer.style['font-size'] = 0;

                    let testContainer = document.createElement('div');
                    testContainer.innerHTML = this.data.text_input;
                    testContainer.style['visibility'] = 'hidden';
                    testContainer.style['width'] = '100%';
                    _.each(this.textStyles, (value, key) => {
                        testContainer.style[key] = value;
                    });

                    parentContainer.appendChild(testContainer);
                    this.$refs.container.appendChild(parentContainer);

                    let scale = 1;
                    let measures = this.measureText(testContainer, scale);

                    if (autoscale < 0) {
                        scale *= Math.sqrt(this.height / measures.y);
                        measures = this.measureText(testContainer, scale);
                    }

                    let width = Math.round(this.width);
                    let height = Math.round(this.height);

                    if (measures.y > height || measures.x > width || autoscale < 0) {
                        // Scale down
                        let upperBound = scale;
                        let lowerBound = scale;

                        // --- Binary Search Algorithm. ---
                        // Find UpperBound
                        for (let i = 0; i <= 8; i++) {
                            measures = this.measureText(testContainer, upperBound);
                            if (measures.x > width || measures.y > height) {
                                break;
                            }
                            upperBound *= Math.max(2, width/measures.x, height/measures.y);
                        }
                        // Find LowerBound
                        for (let i = 0; i <= 8; i++) {
                            measures = this.measureText(testContainer, lowerBound);
                            if (measures.x <= width && measures.y <= height) {
                                break;
                            }
                            lowerBound /= Math.max(2, measures.x/width, measures.y/height);
                        }

                        for (let i = 0; i <= 8; i++) {
                            scale = (lowerBound + upperBound) / 2;
                            measures = this.measureText(testContainer, scale);

                            let heightRatio = measures.y / height;
                            let widthRatio = measures.x / width;

                            if (Math.abs(widthRatio-1) < 0.001 && Math.abs(heightRatio-1) < 0.001) {
                                break;
                            } else if (widthRatio < 1 && Math.abs(heightRatio-1) < 0.001) {
                                break;
                            }

                            if (widthRatio-1 > 0.001 || heightRatio-1 > 0.001) {
                                upperBound = scale;
                            } else {
                                lowerBound = scale;
                            }
                        }
                        // --- Same algorithm as in POV Client code. ---
                        /*
                        let bestHeightRatio = -1;
                        let bestScale = scale;

                        for (let i = 0; i <= 8; i++) {
                            if(measures.x > this.width) {
                                scale *= Math.sqrt(this.width / measures.x);
                            } else {
                                scale *= Math.sqrt(this.height / measures.y);
                            }

                            measures = this.measureText(testContainer, scale);

                            let heightRatio = measures.y / this.height;

                            if (bestHeightRatio > 0) {
                                if (bestHeightRatio === heightRatio && measures.x <= this.width) {
                                    break;
                                }
                            }

                            let compareWidth = 0.999*measures.x; //0.999: approximation margin (such that slightly too large is okay)
                            if (heightRatio < 1 && compareWidth < this.width && heightRatio > bestHeightRatio) {
                                bestHeightRatio = heightRatio;
                                bestScale = scale;
                            }

                            if (compareWidth <= this.width && measures.y < this.height && heightRatio > 0.95) {
                                bestScale = scale;
                                break;
                            }
                        }
                        scale = bestScale;*/
                        scale *= 0.995
                    }

                    this.fontsize = this.fontsize * scale;
                    this.$refs.container.removeChild(parentContainer);
                }
            },
            hexToRgb(hex) {
                let bigint = parseInt(hex, 16);
                let r = (bigint >> 16) & 255;
                let g = (bigint >> 8) & 255;
                let b = bigint & 255;

                return r + "," + g + "," + b;
            },
        },
        mounted: function () {
            this.calcFontWrapper();
            setTimeout(() => {
                this.transitionText = true
            }, 75)
        }
    }
</script>

<style>
.element-text-preview-transitions {
    transition: font-size var(--thumbnail-transition-dimensions-duration) ease-out, text-shadow var(--thumbnail-transition-dimensions-duration) ease-out;
}
</style>
